import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "col-12 bg-white pt-3 border-top strong shadow-top cartTotal d-flex" };
const _hoisted_2 = { class: "text-right" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_product_box_small = _resolveComponent("product-box-small");
    const _component_formatted_price = _resolveComponent("formatted-price");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.current_products, (cart_item, index) => {
            return (_openBlock(), _createBlock(_component_product_box_small, {
                "cart-item": cart_item,
                index: index,
                key: cart_item.id
            }, null, 8, ["cart-item", "index"]));
        }), 128)),
        _createElementVNode("div", _hoisted_1, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mr-auto h5 strong fc-brand_deep_blue" }, "Gesamtpreis:", -1)),
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_formatted_price, {
                    class: "h5 strong fc-brand_deep_blue total_sum",
                    price: _ctx.total
                }, null, 8, ["price"]),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mt-n1 mb-2 small" }, "inkl. MwSt. zzgl. Versand", -1))
            ])
        ])
    ], 64));
}
